import axios from 'axios'
import { extractError } from '../utils/errorHandler'

export const getWorkOrderReport = async (workOrderId) => {
  try {
    const { data: workOrderReport } = await axios.get(
      `report/workOrderFullReport?workOrderId=${workOrderId}`
    )
    return workOrderReport
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const getWorkOrderExecutionFullReport = async (workOrderId, onlySelectedOperation = false) => {
  try {
    const { data: report } = await axios.get(
      `report/workOrderExecutionFullReport?workOrderId=${workOrderId}&onlySelectedOperation=${onlySelectedOperation}`
    )
    return report
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

export const getWorkOrderExecutionFullReportPdf = async (workOrderId, onlySelectedOperation = false) => {
  try {
    const { data } = await axios.get(
      `report/workOrderExecutionFullReportPdf?workOrderId=${workOrderId}&onlySelectedOperation=${onlySelectedOperation}`,
      { responseType: 'blob' }
    )
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

/**
 * Pareto de paradas do período. from/to: datas (YYYY-MM-DD) no fuso do cliente, to inclusive.
 */
export const getStoppagePareto = async (from, to) => {
  try {
    const { data } = await axios.get('report/stoppagePareto', { params: { from, to } })
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

/**
 * Tempos e quantidades para o OEE por estação. from/to: datas (YYYY-MM-DD) no fuso do cliente.
 */
export const getOee = async (from, to) => {
  try {
    const { data } = await axios.get('report/oee', { params: { from, to } })
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

/**
 * Produção por hora e refugo por motivo (Home). from/to: datas (YYYY-MM-DD) no fuso do cliente.
 */
export const getProductionTimeline = async (from, to) => {
  try {
    const { data } = await axios.get('report/productionTimeline', { params: { from, to } })
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}
